const initialState = {
  //   submitType: null,
  submitResponseUrl: null,
  submitResponse: null,
  submitResponseErrors: null,
};

/* ACTIONS */
const SUBMIT_RESPONSE = "app/submitResponse/SUBMIT_RESPONSE";
const SUBMIT_RESPONSE_ERRORS = "app/submitResponse/SUBMIT_RESPONSE_ERRORS";
const CLEAR_SUBMIT_RESPONSE_ERRORS =
  "app/submitResponse/CLEAR_SUBMIT_RESPONSE_ERRORS";
const SUBMIT_RESPONSE_URL = "app/submitResponse/SUBMIT_RESPONSE_URL";
const SUBMIT_RESPONSE_AND_URL = "app/submitResponse/SUBMIT_RESPONSE_AND_URL";

/* REDUCER */
export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    case SUBMIT_RESPONSE:
      return {
        ...state,

        submitResponse: action.payload,
      };

    case SUBMIT_RESPONSE_ERRORS:
      return {
        ...state,

        submitResponseErrors: action.payload.submitResponseErrors,
      };
    case CLEAR_SUBMIT_RESPONSE_ERRORS:
      return {
        ...state,
        submitResponseErrors: null,
      };
    case SUBMIT_RESPONSE_URL:
      return {
        ...state,

        submitResponseUrl: action.payload,
      };
    case SUBMIT_RESPONSE_AND_URL:
      return {
        ...state,
        submitResponse: action.payload.response,
        submitResponseUrl: action.payload.url,
      };

    default:
      return state;
  }
}

/* ACTION CREATORS */

export const setSubmitResponse = (payload: any) => ({
  type: SUBMIT_RESPONSE,
  payload,
});

export const setSubmitResponseErrors = (payload: any) => ({
  type: SUBMIT_RESPONSE_ERRORS,
  payload,
});

export const clearSubmitResponseErrors = () => ({
  type: CLEAR_SUBMIT_RESPONSE_ERRORS,
});

export const setSubmitResponseUrl = (payload: string | null) => ({
  type: SUBMIT_RESPONSE_URL,
  payload,
});

export const setSubmitResponseAndUrl = (payload: {
  response: any;
  url: string | null;
}) => ({
  type: SUBMIT_RESPONSE_AND_URL,
  payload,
});
/* SELECTORS */
export const selectSubmitResponse = (app: any) => app.submitResponse;
